import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { NavItem } from "../nav-item/nav-item";
import { useContext, useEffect, useRef } from "react";
import styles from "./desktop-nav.module.css";
import { SharedUiHeaderV2Context } from "../../context/context-shared-ui-header-v2";
import { PartExchangeMenu } from "../part-exchange-menu/part-exchange-menu";
import { parentLinks } from "../../../data/parent-menu";
import { CarFinanceMenu } from "../car-finance-menu/car-finance-menu";
import { CarCareMenu } from "../car-care-menu/car-care-menu";
import { FindACarMenu } from "../find-a-car/find-a-car-menu";
import { HowCinchWorksMenu } from "../how-cinch-works-menu/how-cinch-works-menu";
import { isChildOf } from "../../utils/is-child";
export var DesktopNav = function(param) {
    var activeMenu = param.activeMenu, handleItemSelection = param.handleItemSelection, children = param.children, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var logicStore = useContext(SharedUiHeaderV2Context).logicStore;
    var navItemDropdownRef = useRef(null);
    var handleTrackEvent = logicStore.handleTrackEvent;
    useEffect(function() {
        activeMenu ? document.body.style.overflowY = "hidden" : document.body.style.overflowY = "auto";
    }, [
        activeMenu
    ]);
    var handleMenuClick = function(evt) {
        if (navItemDropdownRef.current && navItemDropdownRef.current !== evt.target && !isChildOf(evt.target, navItemDropdownRef.current)) {
            handleItemSelection(null);
        }
    };
    var ariaHidden = isMobile ? {
        "aria-hidden": true
    } : {};
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("li", _object_spread_props(_object_spread({
                className: styles.navItem
            }, ariaHidden), {
                children: /*#__PURE__*/ _jsx(NavItem, {
                    href: "#",
                    activeMenu: activeMenu,
                    handleItemSelection: function(selectedMenu) {
                        handleItemSelection(selectedMenu);
                    },
                    title: parentLinks.FINDACAR,
                    handleTrackEvent: function() {
                        return handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.FINDACAR,
                            action: "button"
                        });
                    },
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.navDropdownWrapper,
                        onClick: function(evt) {
                            return handleMenuClick(evt);
                        },
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.navDropdownBG,
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.navItemDropdown,
                                ref: navItemDropdownRef,
                                children: /*#__PURE__*/ _jsx("nav", {
                                    className: styles.menuContainer,
                                    children: /*#__PURE__*/ _jsx(FindACarMenu, {})
                                })
                            })
                        ]
                    })
                })
            })),
            /*#__PURE__*/ _jsx("li", {
                className: styles.navItem,
                children: /*#__PURE__*/ _jsx(NavItem, {
                    href: "#",
                    activeMenu: activeMenu,
                    handleItemSelection: function(selectedMenu) {
                        handleItemSelection(selectedMenu);
                    },
                    title: parentLinks.PARTEXCHANGE,
                    handleTrackEvent: function() {
                        return handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.PARTEXCHANGE,
                            action: "button"
                        });
                    },
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.navDropdownWrapper,
                        onClick: function(evt) {
                            return handleMenuClick(evt);
                        },
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.navDropdownBG,
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.navItemDropdown,
                                ref: navItemDropdownRef,
                                children: /*#__PURE__*/ _jsx("nav", {
                                    className: styles.menuContainer,
                                    children: /*#__PURE__*/ _jsx(PartExchangeMenu, {
                                        handleFaqClick: function() {
                                            return handleItemSelection(null);
                                        }
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("li", {
                className: styles.navItem,
                children: /*#__PURE__*/ _jsx(NavItem, {
                    href: "#",
                    activeMenu: activeMenu,
                    handleItemSelection: function(selectedMenu) {
                        return handleItemSelection(selectedMenu);
                    },
                    title: parentLinks.CARFINANCE,
                    handleTrackEvent: function() {
                        return handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.CARFINANCE,
                            action: "button"
                        });
                    },
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.navDropdownWrapper,
                        onClick: function(evt) {
                            return handleMenuClick(evt);
                        },
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.navDropdownBG,
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.navItemDropdown,
                                ref: navItemDropdownRef,
                                children: /*#__PURE__*/ _jsx("nav", {
                                    className: styles.menuContainer,
                                    children: /*#__PURE__*/ _jsx(CarFinanceMenu, {})
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("li", {
                className: styles.navItem,
                children: /*#__PURE__*/ _jsx(NavItem, {
                    href: "#",
                    activeMenu: activeMenu,
                    handleItemSelection: function(selectedMenu) {
                        handleItemSelection(selectedMenu);
                    },
                    title: parentLinks.CARCARE,
                    handleTrackEvent: function() {
                        return handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.CARCARE,
                            action: "button"
                        });
                    },
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.navDropdownWrapper,
                        onClick: function(evt) {
                            return handleMenuClick(evt);
                        },
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.navDropdownBG,
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.navItemDropdown,
                                ref: navItemDropdownRef,
                                children: /*#__PURE__*/ _jsx("nav", {
                                    className: styles.carCareMenuContainer,
                                    children: /*#__PURE__*/ _jsx(CarCareMenu, {})
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("li", {
                className: styles.navItem,
                children: /*#__PURE__*/ _jsx(NavItem, {
                    href: "#",
                    activeMenu: activeMenu,
                    handleItemSelection: function(selectedMenu) {
                        handleItemSelection(selectedMenu);
                    },
                    title: parentLinks.HOWCINCHWORKS,
                    handleTrackEvent: function() {
                        return handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.HOWCINCHWORKS,
                            action: "button"
                        });
                    },
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.navDropdownWrapper,
                        onClick: function(evt) {
                            return handleMenuClick(evt);
                        },
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.navDropdownBG,
                                "aria-hidden": "true",
                                "data-testid": "dropdown menu background"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.navItemDropdown,
                                ref: navItemDropdownRef,
                                children: /*#__PURE__*/ _jsx("nav", {
                                    className: styles.menuContainer,
                                    children: /*#__PURE__*/ _jsx(HowCinchWorksMenu, {
                                        handleFaqClick: function() {
                                            return handleItemSelection(null);
                                        }
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            children
        ]
    });
};
